export default "__VITE_ASSET__hy9UOPFG__"